import React from "react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import {
  FirstName,
  Phone,
  GenderAdd,
  Age,
  LastName,
  FirstNameKana,
  LastNameKana,
  Email
} from "features/Entries/field-input";

const ModalAddPartner = ({ promotionSet, openFn, open, handleAddPartner , entry}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const [errorDisplay, setErrorDisplay] = useState();

  // check partner with age - gender
  const checkPartner = (data) => {
    const { age, gender } = data;
    if(gender == 1) {
      if(entry.gender1 == '2' && entry.gender2 == '3' && entry.gender3 == '3') {
          setErrorDisplay(`当案件は同行者の登録が女性のみです`);
          return false;
      } else if (entry.gender1 == '3' && entry.gender2 == '2' && entry.gender3 == '3') {
          setErrorDisplay(`当案件は同行者の登録が女性のみです`);
          return false;
      } else if (entry.gender1 == '3' && entry.gender2 == '3' && entry.gender3 == '2') {
          setErrorDisplay(`当案件は同行者の登録が女性のみです`);
          return false;
      } else if (entry.gender1 == '2' && entry.gender2 == '2' && entry.gender3 == '3') {
          setErrorDisplay(`当案件は同行者の登録が女性のみです`);
          return false;
      } else if (entry.gender1 == '3' && entry.gender2 == '2' && entry.gender3 == '2') {
          setErrorDisplay(`当案件は同行者の登録が女性のみです`);
          return false;
      } else if (entry.gender1 == '2' && entry.gender2 == '2' && entry.gender3 == '2') {
          setErrorDisplay(`当案件は同行者の登録が女性のみです`);
          return false;
      } else {
        if(entry.gender1 == '' || entry.gender1 == '0' || entry.gender1 == '1' || entry.gender1 == '3') {
            if(entry.age1_from == '' && entry.age1_to != '') {
                if(age > entry.age1_to) {
                  setErrorDisplay(`男性の${entry.age1_to}才未満の年齢を入力してください`);
                  return false;
                }
            } else if(entry.age1_from != '' && entry.age1_to == '') {
                if(age < entry.age1_from) {
                  setErrorDisplay(`男性の${entry.age1_from}才超過年齢を入力してください`);
                  return false;
                }
            } else if(entry.age1_from != '' && entry.age1_to != '') {
                if(age < entry.age1_from ||  age > entry.age1_to) {
                  setErrorDisplay(`男性:${entry.age1_from}～${entry.age1_to}才以内の年齢を入力してください`);
                  return false;
                }
            }
        }
        
        if(entry.gender2 == '' || entry.gender2 == '0' || entry.gender2 == '1' || entry.gender2 == '3') {
            if(entry.age2_from == '' && entry.age2_to != '') {
                if(age > entry.age2_to) {
                  setErrorDisplay(`男性の${entry.age2_to}才未満の年齢を入力してください`);
                  return false;
                }
            } else if(entry.age2_from != '' && entry.age2_to == '') {
                if(age < entry.age2_from) {
                  setErrorDisplay(`男性の${entry.age2_from}才超過年齢を入力してください`);
                  return false;
                }
            } else if(entry.age2_from != '' && entry.age2_to != '') {
                if(age < entry.age2_from || age > entry.age2_to) {
                  setErrorDisplay(`男性:${entry.age2_from}～${entry.age2_to}才以内の年齢を入力してください`);
                  return false;
                }
            }
        }
        if(entry.gender3 == '' || entry.gender3 == '0' || entry.gender3 == '1' || entry.gender3 == '3') {
            if(entry.age3_from == '' && entry.age3_to != '') {
                if(age > entry.age3_to) {
                  setErrorDisplay(`男性の${entry.age3_to}才未満の年齢を入力してください`);
                  return false;
                }
            } else if(entry.age3_from != '' && entry.age3_to == '') {
                if(age < entry.age3_from) {
                  setErrorDisplay(`男性の${entry.age3_from}才超過年齢を入力してください`);
                  return false;
                }
            } else if(entry.age3_from != '' && entry.age3_to != '') {
                if(age < entry.age3_from || age > entry.age3_to) {
                  setErrorDisplay(`男性:${entry.age3_from}～${entry.age3_to}才以内の年齢を入力してください`);
                  return false;
                }
            }
        }
      }
    } else {
      if(entry.gender1 == '1' && entry.gender2 == '3' && entry.gender3 == '3') {
          setErrorDisplay(`当案件は同行者の登録が男性のみです`);
          return false;
      } else if (entry.gender1 == '3' && entry.gender2 == '1' && entry.gender3 == '3') {
          setErrorDisplay(`当案件は同行者の登録が男性のみです`);
          return false;
      } else if (entry.gender1 == '3' && entry.gender2 == '3' && entry.gender3 == '1') {
          setErrorDisplay(`当案件は同行者の登録が男性のみです`);
          return false;
      } else if (entry.gender1 == '1' && entry.gender2 == '1' && entry.gender3 == '3') {
          setErrorDisplay(`当案件は同行者の登録が男性のみです`);
          return false;
      } else if (entry.gender1 == '3' && entry.gender2 == '1' && entry.gender3 == '1') {
          setErrorDisplay(`当案件は同行者の登録が男性のみです`);
          return false;
      } else if (entry.gender1 == '1' && entry.gender2 == '1' && entry.gender3 == '1') {
          setErrorDisplay(`当案件は同行者の登録が男性のみです`);
          return false;
      } else {
        if(entry.gender1 == '' || entry.gender1 == '0' || entry.gender1 == '2' || entry.gender1 == '3') {
            if(entry.age1_from == '' && entry.age1_to != '') {
                if(age > entry.age1_to) {
                  setErrorDisplay(`女性の${entry.age1_to}才未満の年齢を入力してください`);
                  return false;
                }
            } else if(entry.age1_from != '' && entry.age1_to == '') {
                if(age < entry.age1_from) {
                  setErrorDisplay(`女性の${entry.age1_from}才超過年齢を入力してください`);
                  return false;
                  
                }
            } else if(entry.age1_from != '' && entry.age1_to != '') {
                if(age < entry.age1_from || age > entry.age1_to) {
                  setErrorDisplay(`女性:${entry.age1_from}～${entry.age1_to}才以内の年齢を入力してください`);
                  return false;
                }
            }
        }
        if(entry.gender2 == '' || entry.gender2 == '0' || entry.gender2 == '2' || entry.gender2 == '3') {
            if(entry.age2_from == '' && entry.age2_to != '') {
                if(age > entry.age2_to) {
                  setErrorDisplay(`女性の${entry.age2_to}才未満の年齢を入力してください`);
                  return false;
                }
            } else if(entry.age2_from != '' && entry.age2_to == '') {
                if(age < entry.age2_from) {
                  setErrorDisplay(`女性の${entry.age2_from}才超過年齢を入力してください`);
                  return false;
                }
            } else if(entry.age2_from != '' && entry.age2_to != '') {
                if(age < entry.age2_from || age > entry.age2_to) {
                  setErrorDisplay(`女性:${entry.age2_from}～${entry.age2_to}才以内の年齢を入力してください`);
                  return false;
                }
            }
        }
        if(entry.gender3 == '' || entry.gender3 == '0' || entry.gender3 == '2' || entry.gender3 == '3') {
            if(entry.age3_from == '' && entry.age3_to != '') {
                if(age > entry.age3_to) {
                  setErrorDisplay(`女性の${entry.age3_to}才未満の年齢を入力してください`);
                  return false;
                }
            } else if(entry.age3_from != '' && entry.age3_to == '') {
                if(age < entry.age3_from) {
                  setErrorDisplay(`女性の${entry.age3_from}才超過年齢を入力してください`);
                  return false;
                }
            } else if(entry.age3_from != '' && entry.age3_to != '') {
                if(age < entry.age3_from || age > entry.age3_to) {
                  setErrorDisplay(`女性:${entry.age3_from}～${entry.age3_to}才以内の年齢を入力してください`);
                  return false;
                }
            }
        }
      }
    }
    return true;
  };

  const handleClearErrorAge = () => {
    if (errorDisplay) {
      setErrorDisplay();
    }
  };

  const onSubmit = (data) => {
    if (checkPartner(data)) {
      const partner = {
        promotion_set_id: promotionSet.id,
        action: 0,
        ...data,
      };
      handleAddPartner(partner);
      setErrorDisplay(null);
      reset();
    }
  };

  const closeModal = () => {
    reset();
    openFn("modal-partner");
    setErrorDisplay(null);
  };

  return (
    open && (
      <form onSubmit={handleSubmit(onSubmit)} className="modal rounded-8 active">
        <div className="modal-body">
          <div className="title mt-2 text-black">
            追加する同行者の情報をご入力ください
          </div>

          <div className="px-3 px-md-5 my-4">
            <div className="fw-600">
              <div className="my-1">
                <div className="bg-violet px-3 py-2">
                  <label htmlFor="check3" className="fs-14 lh-1 text-grey">
                    {promotionSet?.name}
                  </label>
                </div>
              </div>
            </div>
            {errorDisplay && (
              <div className="alert alert-danger mt-2">{errorDisplay}</div>
            )}
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  お名前<span>[必須]</span>
                </label>
                <div className="row gx-3">
                  <div className="col-12 col-md-6">
                    <LastName register={register} errors={errors} />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstName register={register} errors={errors} />
                  </div>
                </div>
                <div className="row gx-3 mt-2">
                  <div className="col-12 col-md-6">
                    <LastNameKana register={register} errors={errors} />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstNameKana register={register} errors={errors} />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  年齢<span>[必須]</span> <span>半角数字</span>
                </label>
                <div className="row gx-3">
                  <div className="w-82">
                    <Age
                      register={register}
                      errors={errors}
                      errorAge={errorDisplay ? true : false}
                      clearError={handleClearErrorAge}
                    />
                  </div>
                </div>
                {errors?.age && (
                  <div className="alert alert-danger mt-2">
                    {errors.age?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  性別<span>[必須]</span>
                </label>
                <div>                 
                    <GenderAdd
                      register={register}
                      value="1"
                      id="1"
                      label="男性"
                      errors={errors}
                    />
                
                    <GenderAdd
                      register={register}
                      value="2"
                      id="2"
                      label="女性"
                      errors={errors}
                    />                 
                </div>
                {errors?.gender && (
                  <div className="alert alert-danger mt-2">
                    {errors.gender?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  電話番号<span>[必須]</span>
                  <span>半角数字・ハイフンなし</span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Phone register={register} errors={errors} />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                メールアドレス<span></span>
                  <span></span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Email register={register} errors={errors} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center fw-700 fs-12 flex-wrap text-red">
            <span>※身分証を確認させて頂く場合がございます。</span>
            <span>お間違えのない様にお願いいたします。</span>
          </div>

          <div className="my-3 text-center">
            <button type="submit" className="btn-custom red-light">
              同行者を追加する
            </button>

            <div onClick={closeModal} className="btn-custom mt-2">
              キャンセル
            </div>
          </div>
        </div>
      </form>
    )
  );
};

export default ModalAddPartner;
